import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useAuth0 } from "@auth0/auth0-react";
import { useParams, Link, useNavigate } from "react-router-dom";
import { PageLoader } from "../page-loader";
import {
  saveEvent,
  addSiblings,
  deleteEvent,
  loadEvents
} from "../../redux/actions/eventActions";
import { signUp, unSignUp } from "../../redux/actions/attendingActions";
import { getUserProfile, report } from "../../redux/actions/userActions";
import { loadCities } from "../../redux/actions/cityActions";
import { addNewCategory } from "../../redux/actions/categoryActions";
import { addNewTargetGroup } from "../../redux/actions/targetGroupActions";
import { newEvent } from "../../../tools/mockData";
import { toast } from "react-toastify";
import { getEvent } from "../../api/eventApi";
import { getAttendingNetwork } from "../../api/networkApi";
import Time from "./components/Time";
import Location from "./components/Location";
import Description from "./components/Description";
import EventLink from "./components/EventLink";
import ListBox from "./components/ListBox";
import EventForm from "./formInputs/EventForm";
import Detail from "./components/Detail";
import Report from "../common/Report";
import "./EventPage.css";

const EventPage = () => {
  const userFromState = useSelector(state => state.user);
  const { user, getAccessTokenSilently } = useAuth0();
  const dispatch = useDispatch();
  const { id } = useParams();
  const [event, setEvent] = useState(newEvent);
  const [isEdit, setIsEdit] = useState(false);
  const [errors, setErrors] = useState({});
  const [checkedTargetGroupBoxes, setCheckedTargetGroupBoxes] = useState([]);
  const [customTargetGroup, setCustomTargetGroup] = useState("");
  const [checkedCategoryBoxes, setCheckedCategoryBoxes] = useState([]);
  const [customCategory, setCustomCategory] = useState("");
  const [checkedFoodBoxes, setCheckedFoodBoxes] = useState([]);
  const [isAttending, setIsAttending] = useState(false);
  const [attendingAmount, setAttendingAmount] = useState(0);
  const [attendingNetwork, setAttendingNetwork] = useState([]);
  const [reportReason, setReportReason] = useState("");
  const [occurrences, setOccurrences] = useState([]);
  const [loading, setLoading] = useState(true);
  const [newEventId, setNewEventId] = useState(null);

  useEffect(() => {
    if (id || newEventId) {
      console.log(id, newEventId);
      getEvent(id ? id : newEventId).then(response => {
        console.log(response);
        setEvent(response);
        setCheckedTargetGroupBoxes(response.targetgroups);
        setCheckedCategoryBoxes(response.categories);
        setCheckedFoodBoxes(response.foods);
        if (user && !userFromState.id && event) {
          getUser(response.attending);
        } else if (userFromState.id) {
          setIsAttending(
            response.attending.find(
              attending => attending.id === userFromState.id
            )
          );
        }
        if (user) {
          setAttendingAmount(response.attending.length);
          fetchAttendingNetwork(response.id, userFromState.id);
        }
        setLoading(false);
      });
    } else if (user) {
      console.log("no event id");
      clearEvent();
      setIsEdit(true);
      setLoading(false);
    }
  }, [id, newEventId]);

  function clearEvent() {
    setEvent(newEvent);
          setEvent(prevEvent => ({
            ...prevEvent,
            startdate: new Date().toLocaleString().substring(0, 10),
            starttime: new Date().toLocaleString().substring(11, 16),
            enddate: new Date().toLocaleString().substring(0, 10),
            endtime: new Date().toLocaleString().substring(11, 16)
          }));
    setCheckedTargetGroupBoxes([]);
    setCheckedCategoryBoxes([]);
    setCheckedFoodBoxes([]);
  }

  const getUser = async attending => {
    if (user) {
      console.log("getUser");
      try {
        const accessToken = await getAccessTokenSilently();
        const data = await dispatch(getUserProfile(accessToken));
        setIsAttending(attending.find(attending => attending.id === data.id));
        console.log(data);
      } catch (error) {
        console.log(error);
      }
    }
  };

  useEffect(() => {
    setEvent(prevEvent => ({
      ...prevEvent,
      targetgroups: checkedTargetGroupBoxes,
      categories: checkedCategoryBoxes,
      foods: checkedFoodBoxes
    }));
  }, [checkedTargetGroupBoxes, checkedCategoryBoxes, checkedFoodBoxes]);

  async function fetchAttendingNetwork(eventId) {
    const accessToken = await getAccessTokenSilently();
    getAttendingNetwork(accessToken, eventId).then(response => {
      console.log("attending network:", response);
      if (response && response.length > 0) {
        setAttendingNetwork(
          response.map(tracked => (
            <Link key={tracked.id} to={`/profile/${tracked.id}`}>
              {tracked.name}
            </Link>
          ))
        );
      }
    });
  }

  async function handleAttendClick() {
    setIsAttending(!isAttending);
    if (!isAttending) {
      setAttendingAmount(attendingAmount + 1);
      const accessToken = await getAccessTokenSilently();
      dispatch(signUp(accessToken, event, userFromState.id));
    } else {
      setAttendingAmount(attendingAmount - 1);
      const accessToken = await getAccessTokenSilently();
      dispatch(unSignUp(accessToken, event, userFromState.id));
    }
  }

  function handlReportReasonChange(e) {
    setReportReason(e.target.value);
  }

  async function handleReportSubmit(e) {
    e.preventDefault();
    const accessToken = await getAccessTokenSilently();
    dispatch(report(accessToken, event.id, null, reportReason)).catch(error => {
      console.log(error);
    });
    window.alert("Tack! Detta har nu skickats in för granskning.");
  }

  const handleOnClick = () => {
    if (user) {
      console.log("isEdit", isEdit);
      setIsEdit(true);
    }
  };

  function handleChange(e) {
    const { name, value } = e.target;
    console.log(name, value);
    if (value == "true") {
      console.log("value === true");

      setEvent(prevEvent => ({
        ...prevEvent,
        [name]: 1
      }));
    } else if (value == "false") {
      console.log("value === false");

      setEvent(prevEvent => ({
        ...prevEvent,
        [name]: 0
      }));
    } else {
      setEvent(prevEvent => ({
        ...prevEvent,
        [name]: value
      }));
    }
  }

  function handleOccurrencesChange(e) {
    console.log(e);
    setOccurrences(e);
  }

  const handleTargetGroupCheckboxChange = e => {
    console.log(checkedTargetGroupBoxes);
    const { id, checked } = e.target;
    console.log(customTargetGroup);

    if (checked && id === "alla") {
      setCheckedTargetGroupBoxes([id]);
    } else if (checked) {
      setCheckedTargetGroupBoxes(prevCheckedBoxes => [...prevCheckedBoxes, id]);
    } else {
      setCheckedTargetGroupBoxes(prevCheckedBoxes =>
        prevCheckedBoxes.filter(box => box !== id)
      );
    }
  };

  const handleCategoryCheckboxChange = e => {
    const { id, checked } = e.target;

    if (checked && id === "alla") {
      setCheckedCategoryBoxes([id]);
    } else if (checked) {
      setCheckedCategoryBoxes(prevCheckedBoxes => [...prevCheckedBoxes, id]);
    } else {
      setCheckedCategoryBoxes(prevCheckedBoxes =>
        prevCheckedBoxes.filter(box => box !== id)
      );
    }
  };

  const handleFoodCheckboxChange = e => {
    const { id, checked } = e.target;

    if (checked && id === "alla") {
      setCheckedFoodBoxes([id]);
    } else if (checked) {
      setCheckedFoodBoxes(prevCheckedBoxes => [...prevCheckedBoxes, id]);
    } else {
      setCheckedFoodBoxes(prevCheckedBoxes =>
        prevCheckedBoxes.filter(box => box !== id)
      );
    }
  };

  function formIsValid() {
    console.log(event);
    const { name, address, city, starttime } = event;
    const errors = {};

    if (!name) errors.name = "Name is required.";
    if (!address) errors.address = "Address is required.";
    if (!city) errors.city = "City is required.";
    if (!starttime) errors.starttime = "Starttime is required.";
    console.log(errors);
    setErrors(errors);
    // Form is valid if the errors object still has no properties
    return Object.keys(errors).length === 0;
  }

  const checkCustomCategory = async () => {
    if (customCategory && customCategory != "custom" && checkedCategoryBoxes.find(box => box === "custom")) {
      const formData = {
        value: customCategory
      };
      const accessToken = await getAccessTokenSilently();
      await dispatch(addNewCategory(accessToken, formData));

      //This really has no effect, but it feels wrong not to do it...
      setCheckedCategoryBoxes(prevCheckedBoxes => [
        ...prevCheckedBoxes,
        customCategory
      ]);
      setCheckedCategoryBoxes(prevCheckedBoxes =>
        prevCheckedBoxes.filter(box => box !== "custom")
      );
    }
  };

  const checkCustomTargetgroup = async () => {
    if (
      customTargetGroup && customTargetGroup != "custom" &&
      checkedTargetGroupBoxes.find(box => box === "custom")
    ) {
      const formData = {
        value: customTargetGroup
      };
      console.log(formData);
      const accessToken = await getAccessTokenSilently();
      await dispatch(addNewTargetGroup(accessToken, formData));
      //This really has no effect, but it feels wrong not to do it...
      setCheckedTargetGroupBoxes(prevCheckedBoxes => [
        ...prevCheckedBoxes,
        customTargetGroup
      ]);
      setCheckedTargetGroupBoxes(prevCheckedBoxes =>
        prevCheckedBoxes.filter(box => box !== "custom")
      );
    }
    return checkedTargetGroupBoxes
      .filter(box => box !== "custom")
      .push(customTargetGroup);
  };

  async function handleSave(e) {
    e.preventDefault();
    if (!formIsValid()) return;
    checkCustomTargetgroup();
    checkCustomCategory();
    setLoading(true);
    //put all time specs in occurrences (even if only one event)?
    const formData = buildEventBody();
    console.log(formData);
    const accessToken = await getAccessTokenSilently();
    const newId = await dispatch(saveEvent(accessToken, formData));
    toast.success("Event saved with id: " + newEventId);
    setEvent(formData);
    setEvent(prevEvent => ({
      ...prevEvent,
      id: newEventId
    }));
    await addEventSiblings(formData, newId);
    dispatch(loadEvents(event.startdate, event.city)).catch(error => {
      console.log(error);
    });
    dispatch(loadCities()).catch(error => {
      console.log(error);
    });
    setIsEdit(false);
    setNewEventId(newId);
    setLoading(false);
  }

  function buildEventBody() {
    console.log(checkedTargetGroupBoxes);
    console.log(checkedCategoryBoxes);
    return {
      ...event,
      targetgroups:
        checkedTargetGroupBoxes.find(box => box === "custom")
          ? [...checkedTargetGroupBoxes, customTargetGroup].filter(
              box => box !== "custom"
            )
          : checkedTargetGroupBoxes,
      categories:
      checkedCategoryBoxes.find(box => box === "custom")
          ? [...checkedCategoryBoxes, customCategory].filter(
              box => box !== "custom"
            )
          : checkedCategoryBoxes,
      has_siblings: occurrences.length > 0 ? 1 : 0
    };
  }

  async function addEventSiblings(formData, firstEventId) {
    if (occurrences.length === 0) return;
    //TODO alert if reoccurring: confirm additional dates generated
    const eventSiblings = occurrences.map(occurrence => ({
      ...formData,
      startdate: occurrence.startdate,
      enddate: occurrence.enddate
    }));
    console.log(eventSiblings);
    const accessToken = await getAccessTokenSilently();

    const siblingsIdList = [];
    for (var i = 0; i < eventSiblings.length; i = i + 1) {
      siblingsIdList.push(
        await dispatch(saveEvent(accessToken, eventSiblings[i]))
      ); //return id from api (response.data.id)
      console.log("sibling saved");
    }

    console.log(siblingsIdList);

    if (siblingsIdList.length > 0) {
      const siblingsData = { id: firstEventId, siblings: siblingsIdList };
      await dispatch(addSiblings(accessToken, siblingsData)); //make optimistic api call
      console.log("siblings added");
    }
  }

  const handleDelete = e => {
    e.preventDefault();
    if (window.confirm(`Vill du ta bort händelsen?`)) {
      console.log("delete event id : " + event.id);
      deleteThisEvent();
    } else {
      console.log("cancel");
    }
  };

  const deleteThisEvent = async () => {
    try {
      const accessToken = await getAccessTokenSilently();
      await dispatch(deleteEvent(accessToken, event.id));
      setEvent(null);
      routeChange();
    } catch (error) {
      console.log(error);
    }
  };

  const navigate = useNavigate();
  async function routeChange(e) {
    console.log(e);
    navigate(`/eventlist`);
  }

  if (loading) {
    return (
      <div className="page-layout">
        <PageLoader />
      </div>
    );
  }

  return (!isEdit && id) || (!isEdit && newEventId && event) ? (
    <div className="event-page">
      <h2 className="name">{event.name}</h2>
      <Time
        startdate={event.startdate}
        starttime={event.starttime}
        enddate={event.enddate}
        endtime={event.endtime}
      />
      <Location address={event.address} city={event.city} />
      {event.description && <Description description={event.description} />}
      {event.link && <EventLink link={event.link} />}
      <div className="listboxes">
      {event.targetgroups && event.targetgroups.length > 0 && (
        <ListBox
          className="targetgroup"
          label="Målgrupp"
          items={event.targetgroups}
        />
      )}
      {event.categories && event.categories.length > 0 && (
        <ListBox
          className="category"
          label="Kategori"
          items={event.categories}
        />
      )}
      {event.foods && event.foods.length > 0 && (
        <ListBox
          className="food"
          label="Ätbart"
          items={event.foods}
          cost={event.foods[0].cost}
        />
      )}
      </div>
      {event.registration_needed === 1 && (
        <Detail
          className="register"
          label="OBS: Anmälan krävs! "
          info={event.registration_info}
        />
      )}
      {event.cost != 0 && event.cost != null && (
        <Detail className="cost" label="Kostnad: " info={event.cost} />
      )}
      {user && userFromState && (
        <>
          <div className="attending">
            Antal som kommer: {attendingAmount}
            {isAttending && (
              <>
                <i> -- Du har anmält dig</i>
              </>
            )}
            <br></br>
            {attendingNetwork.length > 0 && (
              <ListBox
                className="network"
                items={attendingNetwork}
                label="Från ditt nätverk: "
              />
            )}
          </div>
          <span className="initiator">
            Skapad av:<br></br>{" "}
            <Link key={event.initiator} to={`/profile/${event.initiator}`}>
              {event.initiator_name}
            </Link>
          </span>
          <div className="line"></div>
          <div className="actions">
            <button className="attend" onClick={handleAttendClick}>
              {!isAttending ? "Jag kommer!" : "Nej förresten..."}
            </button>
            {event.initiator === userFromState.id && (
              <button className="edit" onClick={handleOnClick}>
                Redigera
              </button>
            )}
            <Report
              onChange={handlReportReasonChange}
              onSubmit={handleReportSubmit}
            />
          </div>
        </>
      )}
    </div>
  ) : (
    user && (
      <EventForm
        event={event}
        checkedTargetgroups={checkedTargetGroupBoxes}
        checkedCategories={checkedCategoryBoxes}
        checkedFoods={checkedFoodBoxes}
        onTargetgroupChange={handleTargetGroupCheckboxChange}
        setCustomTargetGroup={setCustomTargetGroup}
        onCategoryChange={handleCategoryCheckboxChange}
        setCustomCategory={setCustomCategory}
        onFoodChange={handleFoodCheckboxChange}
        setOccurrencesList={handleOccurrencesChange}
        onChange={handleChange}
        onSave={handleSave}
        onDelete={handleDelete}
        errors={errors}
      />
    )
  );
};

export default EventPage;
